import { createContext, useContext } from 'react';

// Shared with ConfirmContext.jsx, which provides the value and renders the
// dialog. Split into its own file (react-refresh's "only export components"
// rule wants a component file to export components alone) so useConfirm/
// usePrompt live somewhere other than the ConfirmProvider component itself.
export const ConfirmCtx = createContext(null);

// Replaces window.confirm() with a themed dialog matching the rest of the
// app. Resolves a boolean via a Promise, so call sites read the same as the
// native API did (`if (!(await confirm(...))) return`).
export function useConfirm() {
  const ctx = useContext(ConfirmCtx);
  if (!ctx) throw new Error('useConfirm must be used within a ConfirmProvider');
  return ctx.confirm;
}

// Replaces window.prompt() the same way - resolves the entered string, or
// null if cancelled.
export function usePrompt() {
  const ctx = useContext(ConfirmCtx);
  if (!ctx) throw new Error('usePrompt must be used within a ConfirmProvider');
  return ctx.prompt;
}
